<template>
  <div id="app">
	  <!--需要判断是门户还是论坛 显示的header不同-->
    <app-header v-if="type==1" />
	<Lhead v-if="type==2 && path!='/search'" />
	<breadcrumb v-if="type==1" />
    <router-view class="routerview" :class="[type==2?'typesss':'']"/>
	<app-footer v-if="type==1" />
	<Lbottom v-if="type==2" />
  </div>
</template>

<script>
import Header from "./components/Header.vue"
import Footer from "./components/Footer.vue"
import Lhead from "./components/Lhead.vue"
import Lbottom from "./components/Lbottom.vue"
import { wxlogin } from "@/api/user"
import { getQueryVariable } from "@/utils/rules"
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components:{
	  'app-header':Header,
	  'app-footer':Footer,
	  'Lhead':Lhead,
	  'Lbottom':Lbottom
  },
  data(){
	  return{
		  type:1,
		  path:''
	  }
  },
  watch:{
    $route(to,from){
  	   console.log(to);
	   this.type=to.meta.type
	   this.path = to.path
    }
  },
  mounted(){
	  let that = this;
	  let clientWidth = document.documentElement.clientWidth;
	  //手机端
	 //  if(clientWidth<1200){
		//   location.href = "https://www.metabiz.com.cn/m/#" + this.$route.fullPath
	 //  }
	 //     window.onresize = function () {
		//    if(document.documentElement.clientWidth<1200){
		// 	   that.$nextTick(()=>{
		// 		   location.href = "https://www.metabiz.com.cn/m/#/"
		// 	   })
		//    }
		// };
  },
  created(){
	   this.type = this.$route.meta.type
	   this.path = this.$route.path
  },
  methods:{

  },
}
</script>

<style lang="scss">
	.scroll::-webkit-scrollbar {
					display: none;
		}
	.routerview{
		min-height:calc(100vh - 378px);
		
	}
	.typesss{
		padding-bottom: 50px;
	}
body,html{
	margin: 0;
	background: #f6f8f9;
}
.cl{
	zoom:1;
}
.box{
	background: #fff;
	border-radius: 4px;
	border: 0;
	transition: all .6s ease;
}
.p25{
	padding: 25px!important;
}
.zz_jspc_pdiy{
	margin-bottom: 15px;
	.zz_section_title{
		position: relative;
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
		padding-bottom: 20px;
		font-size: 16px;
		color: #262626;
		border-bottom: 1px solid #f0f0f0;
		overflow: hidden;
	}
}
.plr25{
	padding: 0px 25px!important;
}
.mb15{
	margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue